import { SpinnerGap } from "@phosphor-icons/react";
import tw, { styled } from "twin.macro";
import "styled-components/macro";

export const Spinner = styled(SpinnerGap)`
  ${tw`text-lg animate-spin [animation-duration:800ms] [animation-timing-function:steps(8,_end)]`}
`;
